<div class="lp-template" class="{{size}}">
    <div class="container">
        <div class="logo">
            <a href="/"><img src="../../../assets/img/logo_OK.png" /></a>
        </div>
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>